import { useEffect } from 'react';

import styled from '@emotion/styled';

import { useToastStore } from '@/store/toastStore';

const Toast = () => {
	const { toast, closeToast } = useToastStore();

	useEffect(() => {
		if (!toast) return;

		const timer = setTimeout(() => {
			closeToast();
		}, toast.showTime ?? 3000);

		return () => clearTimeout(timer);
	}, [toast, closeToast]);

	if (!toast) return null;

	return (
		<ToastBox>
			{toast.icon && (
				<ToastIcon>
					{toast.icon === 'alert' ? (
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18" fill="#F41201">
							<path d="M8.5 17.03c-4.43 0-8.03-3.6-8.03-8.03s3.6-8.03 8.03-8.03 8.03 3.6 8.03 8.03-3.6 8.03-8.03 8.03Zm0-14.59C4.88 2.44 1.94 5.39 1.94 9s2.95 6.56 6.56 6.56 6.56-2.95 6.56-6.56-2.95-6.56-6.56-6.56Z" />
							<path d="M8.5 9.73c-.41 0-.73-.33-.73-.73V6.08c0-.41.33-.73.73-.73s.73.33.73.73v2.92c0 .41-.33.73-.73.73Z" />
							<path d="M8.5 12.65c-.41 0-.73-.33-.73-.73s.33-.73.73-.73.73.33.73.73-.33.73-.73.73Z" />
						</svg>
					) : toast.icon === 'confirm' ? (
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" fill="#3870ff">
							<path d="M7.5 13.69c-3.69 0-6.69-3-6.69-6.69s3-6.69 6.69-6.69 6.69 3 6.69 6.69-3 6.69-6.69 6.69Zm0-12.16c-3.02 0-5.47 2.46-5.47 5.47s2.46 5.47 5.47 5.47 5.47-2.46 5.47-5.47-2.46-5.47-5.47-5.47Z" />
							<path d="M7.45 8.22c-.25 0-.49-.16-.58-.4-.11-.32.07-.66.4-.77.36-.12 1.41-.6 1.41-1.23 0-.29-.1-.57-.29-.79a1.47 1.47 0 0 0-1.47-.62c-.36.05-.67.2-.94.37-.29.17-.5.41-.61.72-.11.32-.46.48-.77.38-.32-.1-.49-.46-.38-.78.19-.55.57-1.01 1.07-1.3a2.7 2.7 0 0 1 2.74.04c.56.36.94.92 1.14 1.54.2.63.22 1.3-.14 1.88-.53.89-2.52 1.6-2.65 1.64a.67.67 0 0 1-.18.02Z" />
							<path d="M7.51 10.65c-.34 0-.61-.27-.61-.61s.27-.61.61-.61c.34 0 .61.27.61.61s-.27.61-.61.61Z" />
						</svg>
					) : (
						<img src={toast.icon} alt="icon" loading="lazy" />
					)}
				</ToastIcon>
			)}
			<ToastContent>
				<p>{toast.subContent}</p>
				<Content>{toast.content}</Content>
			</ToastContent>
		</ToastBox>
	);
};

export default Toast;

const ToastBox = styled.div`
	z-index: 999;
	position: fixed;
	bottom: 2rem;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: 1.3em;
	max-width: 44.9rem;
	width: calc(100vw - 4rem); /* 화면 전체 너비에서 좌우 2rem씩 제외 */
	padding: 1.6rem;
	border-radius: ${(props) => props.theme.borderRadius.sm};
	background-color: #292a2d;
	box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
	white-space: nowrap;
`;
const ToastIcon = styled.div`
	width: 1.8rem;
	height: 1.8rem;
	flex-shrink: 0;
`;
const ToastContent = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	color: #e8eaed;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	line-height: 1.875rem;
	letter-spacing: 2%;
`;
const Content = styled.p`
	white-space: pre-line; // 줄바꿈 적용
`;
